import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from "react-redux";
import axios from "../../axios";
import { fetchAllProjects } from "../../actions";
import '../../styles/Login.css';

const Login = () => {

    const dispatch = useDispatch();

    let history = useHistory()

    const [state, setState] = useState({
        username: '',
        password: '',
        usernameError: false,
        passwordError: false
    })

    const onEmailChange = (e) => setState(state => ({ ...state, username: e.target.value, usernameError: false }));
    const onPasswordChange = (e) => setState(state => ({ ...state, password: e.target.value, passwordError: false }));

    const login = () => {

        if(state.username === '' && state.password === ''){
            setState(state => ({ ...state, usernameError: true, passwordError: true }));
        }else if(state.username === ''){
            setState(state => ({ ...state, usernameError: true }));
        }else if(state.password === ''){
            setState(state => ({ ...state, passwordError: true }));
        }else{
            axios.post('/api/auth/login',{
                username: state.username,
                password: state.password
            })
                .then(async res => {
                     localStorage.setItem("access", res.data.accessToken);
                    localStorage.setItem("expiresIn", res.data.expiresIn);
                     await dispatch(fetchAllProjects());
                     setState(state => ({...state, loading: false}))
                     history.push('/')
                })
                .catch(() => {
                    // setState(state => ({...state, invalidPassword: true, invalidUsername: true, loading: false }));
                })
        }
    }

    return(
        <div>
            {/*<div className="login-top-Nav">*/}
            {/*    <div>*/}
            {/*        <p className="login_logo">*/}
            {/*            <span className="data-text">Data</span>*/}
            {/*            <span className="manager-text">Manager</span>*/}
            {/*        </p>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="login_page_container">
                <div className="login_container">
                    <div className="teamsystem_id_container">
                        <h2 className="login_title">Accedi a TeamSystem Drag</h2>
                        <button className="redirect_to_signup_Button" onClick={() => history.push('/login-teamsystem')}>Accedi o registrati con TeamSystem ID</button>
                        <div className="horizontal_line_div">
                            <hr color="#e4eaf0" style={{width: '100%'}}/>
                            <p className="oppure_text">oppure</p>
                            <hr color="#e4eaf0" style={{width: '100%'}}/>
                        </div>
                    </div>
                    <div className="login_form_container">
                        <p className="info_title">Se non disponi di un TeamSystem ID Inserisci le tue credenziali per effettuare l’accesso a TeamSystem Drag.</p>

                        <p className="input_label">Username</p>
                        <input className="login_input" style={{ border: state.usernameError && "1px solid red" }} type="email" value={state.username} onChange={onEmailChange} placeholder="Inserisci Username"/>

                        <p className="input_label" style={{marginTop: '1rem'}}>Password</p>
                        <input className="login_input" type="password" style={{ border: state.passwordError && "1px solid red" }} value={state.password} onChange={onPasswordChange} placeholder="Inserisci password"/>
                        <p className="forgot_password" onClick={() => history.push('/recover-password')}>Password dimenticata?</p>

                        <button className="access_team_button" onClick={login}>Accedi senza TeamSystem ID</button>
                        {/* <button className="redirect_to_signup_Button">Non hai ancora un Account? Registrati adesso</button> */}
                        <button className="no_borders_button" onClick={() => {history.push('/register-drag')}}>Non hai ancora un Account? Registrati adesso</button>
                        {/*<div className="support_info_div">*/}
                        {/*    <p className="support_info">Per maggiori informazioni sulla Privacy, consulta la nostra</p>*/}
                        {/*    <p className="support_info_link">Informativa sul Trattamento dei Dati Personali</p>*/}
                        {/*</div>*/}
                    </div>
                </div>

                <div></div>
            </div>
        </div>
    )
}

export default Login;